import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // localStorage  

// ====== Reducers ======
import UserInfoSlice from "./Reducers/Shared/UserInfo/index";
import FetchDataJson from "./Reducers/Shared/FetchDataJson/index";
import ResearchProposalInformation from "./Reducers/Submitter/ResearchProposalInformation/index";
import DropDownFields from "./Reducers/Submitter/ResearchProposalInformation/FieldDropDown/index";

import DropDown from "./Reducers/Submitter/MainResearcherInformation/DropDown";
import OneInformationAboutResearchers from "./Reducers/Submitter/InformationAboutResearchers/index";
import DropDownSupportType from "./Reducers/Submitter/OtherSupportingParties/SupportTypedDropDown";
import VariousVariables from "./Reducers/Shared/VariousVariables/index";
import FlowComponent from "./Reducers/Manager/FlowComponent/index";
import ImplementationPeriodReducer from "./Reducers/Submitter/ImplementationPeriod/index";
import ApplicationInformation from "./Reducers/Shared/ApplicationInformation/index";

import Objectives from "./Reducers/Submitter/Objectives/index";
import ImplementationStageReducers from "./Reducers/Submitter/ImplementationStages/index";
import ItemTypeReducers from "./Reducers/Submitter/WPBItemType/index";

import ContributionOfSecondTeamReducers from "./Reducers/Submitter/ContributionOfSecondTeam/index";
import BudgetItemsRequestedFromSomanReducers from "./Reducers/Submitter/BudgetItemsRequestedFromSoman/index";
import ObjectivesAndActivitiesReducers from "./Reducers/Submitter/ObjectivesAndActivities/index";

import TimeFrameInformationReducers from "./Reducers/Submitter/TimeFrameInformation/index";
import MainResearcherInformation from "./Reducers/Submitter/MainResearcherInformation";
import PublishedScientificRes from "./Reducers/Submitter/PublishedScientificRes";
import AcademicQualificationsDegree from "./Reducers/Submitter/AcademicQualificationsDegree";
import Patents from "./Reducers/Submitter/Patents";
import ResearchExperience from "./Reducers/Submitter/ResearchExperience";
import GeneralInformation from "./Reducers/Submitter/GeneralInformation";
import InformationAboutScientificInstitution from "./Reducers/Submitter/InformationAboutScientificInstitution";
import Attachments from "./Reducers/Submitter/Attachments";
import DropDownAcademicDegree from "./Reducers/Submitter/InformationAboutResearchers/AcademicDegreeDropdown/index";
import OneOtherSupportingParties from "./Reducers/Submitter/OtherSupportingParties/index";
import Acknowledgement from "./Reducers/Submitter/Acknowledgement";
import FindOutAward from "./Reducers/Submitter/FindOutAward";

import DetailsBudgetReducers from "./Reducers/Submitter/DetailsBudget/iindex";

import ConflictOfInterest from "./Reducers/Submitter/ConflictsOfInterestAndResearchEthics/index";
import ValidateAllPages from "./Reducers/Submitter/ValidateAllPages";

import RoundReducers from "./Reducers/Shared/Round/index";
import ApplicationInformationReducers from "./Reducers/Shared/ApplicationInformation/index";
import Login from "./Reducers/Shared/Login/index";

import YesNoManager from "./Reducers/Manager/YesNo/index";
import MarksManager from "./Reducers/Manager/Marks/index";
// import WorkFlow from "./Reducers/Manager/WorkFlow/index";
import DropDownRoundActive from "./Reducers/Manager/Dropdowns/GetAllRoundActive";
import DropDownFlow from "./Reducers/Manager/Dropdowns/GetAllFlow";
import DropDownActionByFlowId from "./Reducers/Manager/Dropdowns/GetActionByFlowId";
import TasksByRoundAndFiled from "./Reducers/Manager/Tasks/TasksByRoundAndFiled";
import Summary from "./Reducers/Manager/Summary/index";

import ApplicationInfo from "./Reducers/Manager/ApplicationInformation/index";
import FlowActionByTaskId from "./Reducers/Manager/FlowAction/index";

import RecommendationByActionId from "./Reducers/Manager/Dropdowns/RecommendationByActionId";

import DropDownFieldsManager from "./Reducers/Manager/Dropdowns/GetAllFieldByRound";

import StepsWorkFlow from "./Reducers/Manager/WorkFlowStep/index";

import arrayDataCheckBoks from "./Reducers/Shared/CheckBox/index";
import globalLoadingSlice from "./Reducers/Shared/globalLoading/index";
// import WorkFlowStep from "./Reducers/Manager/WorkFlowStep/index";
import ActionReducer from "./Reducers/Manager/Action/index";
import FieldRondReducer from "./Reducers/Manager/Dropdowns/FieldRond";
import EvaluatorInfo from "./Reducers/Manager/EvaluatorInfo/index";
import DropDownEvaluator from "./Reducers/Manager/Dropdowns/GetAllEvaluator";
import SubTaskReducer from "./Reducers/Manager/SubTask/index";
import ChangeAssigingUser from "./Reducers/Manager/ChangeAssigingUser/index";
import RoleByUserGuid from "./Reducers/Shared/RoleByUser/index";
import Activities from "./Reducers/ReportStage/Activities";
import ActivitiesForStage from "./Reducers/ReportStage/ActivitiesForStage";
import BudgetItems from "./Reducers/ReportStage/BudgetItems";
import BudgetItemsForStage from "./Reducers/ReportStage/BudgetItemsForStage";
import IndirectBeneficiaries from "./Reducers/ReportStage/IndirectBeneficiaries";
import JustificationsforTransfer from "./Reducers/ReportStage/JustificationsforTransfer";
import ProjectExtensionRequestDetails from "./Reducers/ReportStage/ProjectExtensionRequestDetails";
import ProjectModificationRequests from "./Reducers/ReportStage/ProjectModificationRequests";
import ReportStatus from "./Reducers/ReportStage/Report";
import ReturnComments from "./Reducers/ReportStage/ReturnComments";
import SubObjectives from "./Reducers/ReportStage/SubObjectives";
import SubObjectivesForStage from "./Reducers/ReportStage/SubObjectivesForStage";
import TransferRequestDetails from "./Reducers/ReportStage/TransferRequestDetails";
import StartProgressReportReducer from "./Reducers/ReportStage/StartProgressReport";
import ReportingPhaseReducer from './Reducers/ReportStage/ReportingPhase'
import DropDownRequestType from './Reducers/ReportStage/Dropdowns/RequestType'
import TransferRoleReducer from './Reducers/ReportStage/TransferRole/index'
import QuestionSelectableTagsList  from "./Reducers/Manager/Dropdowns/QuestionSelectableTagsList";
// ====== Combine all reducers ======
const rootReducer = combineReducers({
  UserInfo: UserInfoSlice,
  FetchDataJson,
  ResearchProposalInformation,
  DropDownFields,
  OneInformationAboutResearchers,
  OneOtherSupportingParties,
  DropDownSupportType,
  refreshTableStatus: VariousVariables,
  ImplementationPeriod: ImplementationPeriodReducer,
  ApplicationInformationReducer: ApplicationInformation,
  ConflictOfInterest,
  ObjectivesReducer: Objectives,
  ImplementationStageReducers,
  ItemTypeReducers,
  ContributionOfSecondTeamReducers,
  BudgetItemsRequestedFromSomanReducers,
  ObjectivesAndActivitiesReducers,
  MainResearcherInformation,
  TimeFrameInformationReducers,
  PublishedScientificRes,
  AcademicQualificationsDegree,
  DropDownAcademicDegree,
  DropDown,
  Patents,
  ResearchExperience,
  GeneralInformation,
  InformationAboutScientificInstitution,
  Attachments,
  DetailsBudgetReducers,
  ValidateAllPages,
  RoundReducers,
  ApplicationInformationReducers,
  Login,
  Acknowledgement,
  FindOutAward,
  arrayDataCheckBoks: arrayDataCheckBoks,
  /////////////////////////////Manager//////////////////////////////////////
  YesNoManager,
  MarksManager,
  ActionReducer,
  // WorkFlow,
  DropDownRoundActive,
  DropDownFlow,
  DropDownActionByFlowId,
  TasksByRoundAndFiled,
  DropDownFieldsManager,
  Summary,
  ApplicationInfo,
  FlowActionByTaskId,
  RecommendationByActionId,
  // WorkFlowStep,
  globalLoading: globalLoadingSlice, // إضافة reducer للمراقبة
  FlowComponent,
  FieldRondReducer,
  EvaluatorInfo,
  DropDownEvaluator,

  SubTaskReducer,
  StepsWorkFlow,
  ChangeAssigingUser,
  RoleByUserGuid,
  QuestionSelectableTagsList,
  ///////////RS///////////////
  Activities,
  ActivitiesForStage,
  BudgetItems,
  BudgetItemsForStage,
  IndirectBeneficiaries,
  JustificationsforTransfer,
  ProjectExtensionRequestDetails,
  ProjectModificationRequests,
  ReportStatus,
  ReturnComments,
  SubObjectives,
  SubObjectivesForStage,
  TransferRequestDetails,
  StartProgressReportReducer,
  ReportingPhaseReducer,
  DropDownRequestType,
  TransferRoleReducer
});

// ====== Redux Persist Configuration ======
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["UserInfo", "Login", "arrayDataCheckBoks", "RoleByUserGuid"], // فقط حفظ هذين
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// ====== Store & Persistor ======
export const store = configureStore({
  reducer: persistedReducer,
  devTools: true,
});

export const persistor = persistStore(store);
